import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { phoneNumberFormatter } from '@dreryk/react-common';

type PhoneNumberCellProps = {
   readonly phoneNumber: PhoneNumber | null | undefined;
};

export const PhoneNumberCell = ({ phoneNumber }: PhoneNumberCellProps): JSX.Element => (
   <>{phoneNumberFormatter(phoneNumber)}</>
);
